interface MediaItem {
  thumbnail: string;
  alt: string;
  title: string;
  source: string;
  duration: string;
  views: string;
}

const mediaItems: MediaItem[] = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20video%20thumbnail%20style%20illustration%2C%20celebrity%20interview%20theme%2C%20warm%20coral%20peach%20gradient%20tones%2C%20play%20button%20overlay%20design%2C%20modern%20minimal%20composition%2C%20clean%20cream%20background%2C%20editorial%20style&width=600&height=340&seq=media-melon-01&orientation=landscape',
    alt: '顶流男星恋情视频速递',
    title: '顶流男星深夜约会全记录：从餐厅到公寓全程回顾',
    source: '网友实拍',
    duration: '02:35',
    views: '128 万次播放',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20clip%20illustration%2C%20dramatic%20conflict%20scene%2C%20warm%20orange%20peach%20gradient%20tones%2C%20play%20button%20design%2C%20modern%20flat%20composition%2C%20clean%20cream%20background%2C%20editorial%20minimalist%20style&width=600&height=340&seq=media-melon-02&orientation=landscape',
    alt: '综艺翻车现场视频速递',
    title: '综艺现场冲突完整版流出：两位嘉宾到底为什么翻脸',
    source: '现场观众',
    duration: '05:18',
    views: '96 万次播放',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20influencer%20interview%20illustration%2C%20tax%20scandal%20theme%2C%20warm%20coral%20peach%20gradient%20tones%2C%20play%20button%20design%2C%20modern%20flat%20composition%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20minimalist&width=600&height=340&seq=media-melon-03&orientation=landscape',
    alt: '网红偷税报道视频速递',
    title: '深度解读：千万网红偷税案始末，背后产业链大起底',
    source: '行业分析',
    duration: '08:42',
    views: '215 万次播放',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20video%20illustration%2C%20divorce%20rumor%20theme%2C%20warm%20orange%20peach%20gradient%20tones%2C%20play%20button%20design%2C%20modern%20flat%20composition%2C%20clean%20cream%20background%2C%20editorial%20minimalist%20style&width=600&height=340&seq=media-melon-04&orientation=landscape',
    alt: '明星夫妻关系视频速递',
    title: '模范夫妻人设崩塌时间线：从恩爱到分居的那些蛛丝马迹',
    source: '圈内揭秘',
    duration: '06:20',
    views: '89 万次播放',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20film%20set%20accident%20video%20illustration%2C%20movie%20production%20theme%2C%20warm%20coral%20peach%20gradient%20tones%2C%20play%20button%20design%2C%20modern%20flat%20composition%2C%20clean%20cream%20background%2C%20editorial%20style&width=600&height=340&seq=media-melon-05&orientation=landscape',
    alt: '电影拍摄现场视频速递',
    title: '独家还原电影拍摄事故现场：安全措施到底哪里出了问题',
    source: '业内分析',
    duration: '04:55',
    views: '67 万次播放',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            视频速递
          </h2>
          <p className="text-sm text-foreground-500">
            图文不过瘾？视频速递带你还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-accent-300/60 transition-colors"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-foreground-900/70 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">
                  <strong>{item.title}</strong>
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{item.source}</span>
                  <span className="w-px h-3 bg-background-300/60"></span>
                  <span className="whitespace-nowrap">{item.views}</span>
                </div>
              </div>
            </div>
          ))}

          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {mediaItems.slice(3).map((item) => (
              <div
                key={item.title}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-accent-300/60 transition-colors flex flex-col sm:flex-row"
              >
                <div className="relative w-full sm:w-56 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={item.thumbnail}
                    alt={item.alt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900/70 text-background-50">
                      <i className="ri-play-fill text-lg ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 text-xs px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 font-medium">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4 flex flex-col justify-center flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 mb-2">
                    <strong>{item.title}</strong>
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="whitespace-nowrap">{item.source}</span>
                    <span className="w-px h-3 bg-background-300/60"></span>
                    <span className="whitespace-nowrap">{item.views}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}